<template>
  <div class="dashboard"/>
</template>

<script>
export default {

}
</script>

<style>

</style>